export const SMART_GROUPS = {
    CREATE_CONTACT_GROUP: "create-contact-group",
    DIALOG_SELECT_SMART: "dialog-select-smart",
    DIALOG_SELECT_STATIC: "dialog-select-static",
    DIALOG_CREATE_NEW: "dialog-create-new",
    EDIT: "edit",
    DELETE: "delete",
    DIALOG_DELETE: "dialog-delete",
    RECIPIENT_LIST: "recipient-list",
    SHARED: "shared",
    PRIVATE: "private",
    DESCRIPTION: "description",
};
